import {GET_INFO} from '/redux/action/currentUser.action';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';

export default () => (next: any) => (action: any) => {
  const {type: actionType, payload = {}} = action;

  return Promise.resolve(next(action)).then(() => {
    if (actionType === GET_INFO) {
      const {
        coach: {id},
      } = payload;
      getAnalyticsUtilDefaultInstance().trackUserId({optaviaId: id});
    }
  });
};
